<template>
  <div style="position: relative">
    <v-premium-plan-popup
      v-if="$store.getters.getPackage != 'premium'"
      :show-all="false"
      margin-top="65"
      style="border-radius: 5px"
    ></v-premium-plan-popup>
    <v-container>
      <div>
        <h3 class="headline">{{ $t('Cart Summary History') }}</h3>
        <v-layout row wrap>
          <v-flex sm12 xs12 class="mb-4">
            <div>
              <date-filter
                v-model="selectedDate"
                :default-filter="'today'"
                @changeDate="onDateChanged"
              ></date-filter>
            </div>

            <v-divider class="mt-3"></v-divider>
          </v-flex>
          <v-flex sm6 xs12>
            <div
              class="nav nav-tabs"
              style="margin-bottom: 10px; overflow-x: auto; white-space: nowrap"
            >
              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterApp != 'all'"
                :color="filterApp != 'all' ? 'grey' : 'primary'"
                @click="filterApp = 'all'"
                >{{ $t('All') }} {{ `(${rawusers.length})` }}</v-btn
              >
              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterApp != 'facebook'"
                :color="filterApp != 'facebook' ? 'grey' : 'primary'"
                @click="filterApp = 'facebook'"
                >{{ $t('facebook') }} {{ `(${facebooklength})` }}</v-btn
              >
              <v-btn
                small
                depressed
                class="ma-1"
                :outline="filterApp != 'line'"
                :color="filterApp != 'line' ? 'grey' : 'primary'"
                @click="filterApp = 'line'"
                >{{ $t('line') }} {{ `(${linelength})` }}</v-btn
              >
            </div>
          </v-flex>
          <v-flex xs12 sm6 class="text-xs-right">
            <v-btn color="grey" outline class="ma-0 mb-1" @click="exportCartSummary">
              <em class="fas fa-file-export mr-1" />
              {{ $t('export') }}
            </v-btn>
            <v-btn icon color="primary" outline class="ma-0 mb-1 ml-2" @click="getUser">
              <v-icon>refresh</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs12 sm12>
            <div>
              <div
                v-if="isCentralLive"
                class="nav nav-tabs"
                style="margin-bottom: 10px; overflow-x: auto; white-space: nowrap"
              >
                <v-btn
                  small
                  depressed
                  class="ma-1"
                  :outline="filterCategoryStatus != 'all'"
                  :color="filterCategoryStatus != 'all' ? 'grey' : 'primary'"
                  @click="filterCategoryStatus = 'all'"
                  >{{ $t('All') }}</v-btn
                >
                <v-btn
                  v-for="(category, k) in categories"
                  :key="k"
                  small
                  depressed
                  class="ma-1"
                  :outline="filterCategoryStatus != category"
                  :color="filterCategoryStatus != category ? 'grey' : 'primary'"
                  @click="filterCategoryStatus = category"
                  >{{ category }}</v-btn
                >
              </div>
            </div>
          </v-flex>
          <v-flex xs12 class="text-xs-left">
            <v-layout>
              <v-flex
                v-if="
                  ['109154847972476', '109181747969457', '178737485661189'].includes(
                    selectedBot.pageid
                  )
                "
                xs6
                class="pr-2"
              >
                <Multiselect
                  v-model="filter.page"
                  placeholder="เลือกเพจ"
                  :options="pageOptions"
                  label="text"
                  track-by="value"
                  :allow-empty="false"
                  :show-labels="false"
                  @input="onFilter"
                ></Multiselect>
              </v-flex>
              <v-flex xs6 class="pl-2">
                <Multiselect
                  v-model="filter.type"
                  placeholder="เลือกประเภท"
                  :options="typeOptions"
                  label="text"
                  track-by="value"
                  @input="onFilter"
                ></Multiselect>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-data-table
          v-model="selectedUsers"
          expand
          :loading="loading"
          :pagination.sync="pagination"
          :headers="headers"
          :items="filteredUser"
          class="elevation-1 scgallrenttable"
        >
          <!-- select-all -->
          <template #items="props">
            <tr style="cursor: pointer">
              <td class="text-xs-left" @click="showCartDialog(props.item.id)">
                {{ props.item.cartid }}
              </td>
              <template v-if="selectedBot.theme === 'scgdistribution'">
                <td class="text-xs-left" @click="showCartDialog(props.item.id)">
                  {{ props.item.cardnumber }}
                </td>
                <td class="text-xs-left" @click="showCartDialog(props.item.id)">
                  {{ props.item.realname }}
                </td>
                <td class="text-xs-left" @click="showCartDialog(props.item.id)">
                  {{ props.item.address }}
                </td>
              </template>
              <td class="text-xs-left" @click="showCartDialog(props.item.id)">
                {{ props.item.name }}
              </td>
              <td class="text-xs-center" @click="showCartDialog(props.item.id)">
                {{ props.item.productname ? props.item.productname : '-' }}
              </td>
              <td class="text-xs-center" @click="showCartDialog(props.item.id)">
                {{ props.item.quantity | numberFormat }}
              </td>
              <td class="text-xs-center" @click="showCartDialog(props.item.id)">
                {{ props.item.option }}
              </td>
              <td class="text-xs-center" @click="showCartDialog(props.item.id)">
                {{ props.item.discountprice }}
              </td>
              <td class="text-xs-center" @click="showCartDialog(props.item.id)">
                {{ props.item.discountprice }}
              </td>
              <td class="text-xs-center" @click="showCartDialog(props.item.id)">
                {{ props.item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}
              </td>
              <td class="text-xs-center" @click="showCartDialog(props.item.id)">
                {{ props.item.pagename }}
              </td>
              <td class="text-xs-center" @click="showCartDialog(props.item.id)">
                {{ props.item.isschedule ? 'รายวัน' : 'Clear ตะกร้า' }}
                {{ props.item.history_timestamp | DateFormat('DD/MM/YYYY HH:mm') }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-container>
    <div>
      <v-dialog v-model="showCart" width="660" persistent>
        <v-card>
          <div class="text-xs-right">
            <v-btn icon small @click="close">
              <v-icon small>close</v-icon>
            </v-btn>
          </div>
          <div>
            <v-layout>
              <v-flex class="text-xs-left my-2 ma-2">
                <span>{{ $t('Total') }}</span>
                <span class="primary--text" style="font-weight: 500">
                  {{ cartitem.total | numberFormat }}
                </span>
              </v-flex>
              <v-flex class="text-xs-right">
                <v-btn outline color="primary" @click="onDeleteSelected">
                  <v-icon class="mr-1">remove_shopping_cart</v-icon>
                  {{ $t('Clear cart') }}
                </v-btn>
              </v-flex>
            </v-layout>
            <v-data-table
              expand
              :loading="cartloading"
              :pagination.sync="pagination"
              :headers="cartheaders"
              :items="cartitem.cartarray"
              class="elevation-1 scgallrenttable"
            >
              <template #items="props">
                <tr>
                  <td class="text-xs-center">
                    <v-avatar tile size="45">
                      <img
                        v-if="props.item.photourl"
                        :src="props.item.photourl.split(';;')[0]"
                        width="30"
                        height="30"
                        :alt="props.item.name"
                        @error="onFailLoad"
                      />
                      <img
                        v-else
                        :src="'/static/img/assets/livechat/profile.png'"
                        width="30"
                        height="30"
                        :alt="props.item.name"
                      />
                    </v-avatar>
                  </td>
                  <td class="text-xs-center">{{ props.item.name }}</td>
                  <td class="text-xs-center">{{ props.item.option }}</td>
                  <td class="text-xs-center">{{ props.item.quantity | numberFormat }}</td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import DateFilter from '@/components/view/dashboard/DateFilter'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    DateFilter,
    Multiselect
  },
  data() {
    return {
      filterCategoryStatus: 'all',
      selectedDate: {
        start: moment().format('YYYY-MM-DD') + ' 00:00',
        end: moment().format('YYYY-MM-DD') + ' 23:59'
      },
      cartitem: [],
      search: '',
      filterApp: 'all',
      showCart: false,
      pagination: { sortBy: 'none', descending: true, rowsPerPage: 25 },

      cartheaders: [
        {
          text: '',
          value: 'photourl',
          align: 'center',
          width: '3%'
        },
        {
          text: this.$t('name'),
          value: 'name',
          align: 'center',
          width: '3%'
        },
        {
          text: this.$t('option'),
          value: 'option',
          align: 'center',
          width: '1%'
        },
        {
          text: this.$t('Quantity'),
          value: 'quantity',
          align: 'center',
          width: '1%'
        }
        // {
        //   text: this.$t('Price'),
        //   value: 'discountprice',
        //   align: 'center',
        //   width: '2%'
        // }
      ],
      loading: false,
      cartloading: false,
      rawusers: [],
      products: [],
      selectedUsers: [],
      selectedUser: null,
      showsearch: false,
      filter: {
        fullname: '',
        page: '',
        type: '',
        roundStart: '',
        roundEnd: ''
      },
      pageOptions: [
        {
          text: 'All',
          value: ''
        },
        {
          text: 'Test SCG West Live',
          value: '108496771338010'
        },
        {
          text: 'Western Chang Family Live',
          value: '100378482209868'
        },
        {
          text: 'Eastern Chang Family Live',
          value: '107060654853653'
        },
        {
          text: 'Chang Family Live Fair',
          value: '109181747969457'
        },
        {
          text: 'Esan Chang Family Live',
          value: '103800371873416'
        },
        {
          text: 'สุทธิพงศ์ ค้าส่ง Live',
          value: '108308318379330'
        },
        {
          text: 'สินค้าซิเมนต์ไทย ค้าส่ง Live',
          value: '101127682506041'
        },
        {
          text: 'Northern Chang Family Live',
          value: '100274418904517'
        },
        {
          text: 'Sukhothaicemen Live',
          value: '108556638438120'
        },
        {
          text: 'Northern2 Chang Family Live',
          value: '108026141827592'
        },
        {
          text: 'เอสซีจี โฮมบุญถาวร ชุมแพ-เปรมปรีดิ์',
          value: '490162721055346'
        },
        {
          text: 'NPD - Test Live',
          value: '115739694445355'
        },
        {
          text: 'Southern Chang Family Live',
          value: '100396882225293'
        },
        {
          text: 'YALA YONG HUAD ยะลาย่งฮวด',
          value: '178737485661189'
        }
      ],
      typeOptions: [
        {
          text: 'รายวัน',
          value: true
        },
        {
          text: 'Clear ตะกร้า',
          value: false
        }
      ]
    }
  },
  computed: {
    headers() {
      if (this.selectedBot.theme === 'scgdistribution') {
        return [
          // {
          //   text: '',
          //   value: '',
          //   align: 'center',
          //   width: '3%',
          //   sortable: false,
          // },
          // {
          //   text: '',
          //   value: 'photourl',
          //   align: 'center',
          //   width: '3%',
          //   sortable: false,
          // },

          {
            text: 'Transaction ID',
            value: 'transactionId',
            align: 'center',
            width: '3%',
            sortable: false
          },
          {
            text: this.$t('Shop code'),
            value: 'cardnumber',
            align: 'left',
            width: 'auto'
          },
          {
            text: this.$t('Shop name'),
            value: 'realname',
            align: 'left',
            width: 'auto'
          },
          {
            text: this.$t('Province'),
            value: 'province',
            align: 'left',
            width: 'auto'
          },
          {
            text: this.$t('Name'),
            value: 'name',
            align: 'left',
            width: 'auto'
          },
          {
            text: this.$t('Product name'),
            value: 'productname',
            align: 'center',
            width: '1%'
          },
          {
            text: this.$t('Quantity'),
            value: 'quantity',
            align: 'center',
            width: '1%'
          },
          {
            text: this.$t('Unit'),
            value: 'unit',
            align: 'center',
            width: '1%'
          },
          {
            text: this.$t('Price'),
            value: 'price',
            align: 'center',
            width: '1%'
          },
          {
            text: this.$t('Discount Price'),
            value: 'discountPrice',
            align: 'center',
            width: '1%'
          },

          // {
          //   text: this.$t('Cart price'),
          //   value: 'cartprice',
          //   align: 'center',
          //   width: '1%',
          // },
          {
            text: this.$t('Date') + ' / ' + this.$t('Time'),
            value: 'timestamp',
            align: 'center',
            width: '1%'
          },
          {
            text: 'Facebook Page',
            value: 'facebookPage',
            align: 'center',
            width: '3%'
          },
          {
            text: 'รอบ',
            value: 'round',
            align: 'center',
            width: '3%'
          }
          // {
          //   text: this.$t('Inbox'),
          //   value: 'inboxurl',
          //   align: 'center',
          //   width: '2%',
          // },
        ]
      } else {
        return []
      }
    },
    categories() {
      var uniq = [...new Set(this.rawusers.map((el) => el.categoryname))]
      return uniq
    },
    ...mapGetters(['selectedBot']),
    facebooklength() {
      return this.rawusers.filter((el) => el.app == 'facebook').length
    },
    linelength() {
      return this.rawusers.filter((el) => el.app == 'line').length
    },
    isCentralLive() {
      return this.$store.state.centralPage.includes(this.selectedBot.pageid)
    },
    filteredUser() {
      var result
      var user = this.rawusers
      if (this.search) {
        user = user.filter((val) => val.name.toLowerCase().includes(this.search.toLowerCase()))
      }
      result = user.filter((el) => {
        if (this.filterApp != 'all') {
          return el.app == this.filterApp
        } else {
          return true
        }
      })
      if (this.filterCategoryStatus != 'all') {
        result = result.filter((el) => el.categoryname == this.filterCategoryStatus)
      }
      return result
    }
  },
  mounted() {
    if (
      ['109154847972476', '109181747969457', '178737485661189'].includes(this.selectedBot.pageid)
    ) {
      let currentPage = this.pageOptions.filter((el) => {
        if (el.value == this.selectedBot.pageid) {
          return el
        }
      })
      this.filter.page = currentPage
    }
    this.getUser()
  },
  methods: {
    deleteItem(item) {
      this.$swal
        .fire({
          text: 'ต้องการลบรายการนี้ ?',
          showCancelButton: true
        })
        .then((result) => {
          if (result.value) {
            this.loading = true
            var data = {
              pageid: this.selectedBot.pageid,
              cartid: item.cartid
            }
            console.log(item)
            api.deletecmsviewcartbyid(data, () => {
              this.loading = false
              this.getUser()
            })
          }
        })
    },
    onSearch() {
      this.showsearch = false
      this.getUser()
    },
    clearsearch() {
      this.filter = {
        fullname: '',
        page: '',
        type: '',
        round: ''
      }
      this.showsearch = false
      this.onSearch()
    },
    onEditAddress(type, payload, item) {
      var vm = this
      vm.$store.dispatch('loading')

      var data = {
        pageid: this.selectedBot.pageid,
        usersid: payload.usersid,
        address: payload.customer_value
      }
      api.saveUserAddress(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }

        vm.$store.dispatch('loading')
        this.$set(item, type, payload.customer_value)
      })
    },
    putuserrealname(type, payload, item) {
      var vm = this

      this.$set(item, type, payload.customer_value)

      vm.$store.dispatch('loading')
      var data = {
        body: {
          usersid: item.id,
          realname: payload.customer_value
        },
        params: {
          pageid: this.selectedBot.pageid
        }
      }
      api.putuserrealname(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
        vm.getUser()
        vm.$forceUpdate()
      })
    },
    putusercardnumber(type, payload, item) {
      var vm = this
      this.$set(item, type, payload.customer_value)

      vm.$store.dispatch('loading')
      var data = {
        body: {
          usersid: item.id,
          cardnumber: payload.customer_value
        },
        params: {
          pageid: this.selectedBot.pageid
        }
      }
      api.putusercardnumber(data, function (error) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
        vm.getUser()
        vm.$forceUpdate()
      })
    },
    async onDeleteSelected() {
      if (this.selectedUser) {
        this.selectedUsers.push(this.selectedUser)
        await this.onDeleteAllInCart()
        this.showCart = false
      }
    },
    async onDeleteAllInCart() {
      var result = await this.$swal.fire({
        title: this.$t('Do you want to clear cart'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })

      if (result.value) {
        var userid = this.selectedUsers.map((el) => {
          return el.id
        })
        this.loading = true
        await this.deleteAllInCart(userid)
        this.rawusers = this.rawusers.filter((el) => !userid.includes(el.id))

        this.loading = false
      }
    },
    deleteAllInCart(userid) {
      return new Promise((resolve, reject) => {
        if (!this.selectedUsers || this.selectedUsers.length == 0) {
          reject()
        }
        var data = {
          pageid: this.selectedBot.pageid,
          userid_arr: userid
        }
        api.deleteAllInCart(data, (error, response) => {
          if (error) {
            console.error(error)
          }
          resolve(response)
        })
      })
    },
    onDateChanged() {
      // this.filter.fullname = ''
      this.getUser()
    },
    close() {
      this.cartitem = []
      this.showCart = false
    },
    viewInbox(link) {
      window.open(link, '_blank')
    },
    showCartDialog(id) {
      this.showCart = id

      var user = this.rawusers.find((el) => {
        return el.id == id
      })
      this.selectedUser = user
      this.getCart(id)
    },
    getCart(id) {
      this.cartloading = true
      api.getusercart({ pageid: this.selectedBot.pageid, userid: id }, (err, response) => {
        this.cartloading = false
        if (response && response.cartarray) {
          this.cartitem = response
        }
      })
    },
    onFailLoad: function (e) {
      // console.log(e)
      e.target.src = '/static/img/assets/livechat/profile.png'
      // this.$set(this.user, 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getUser() {
      this.loading = true

      var pageid = ''
      if (
        ['109154847972476', '109181747969457', '178737485661189'].includes(this.selectedBot.pageid)
      ) {
        pageid = ''
        if (this.filter.page) {
          pageid = this.filter.page.value
        } else {
          pageid = this.selectedBot.pageid
        }
      } else {
        pageid = this.selectedBot.pageid
      }

      var data = {
        pageid: pageid,
        startdate_history: this.selectedDate.start,
        enddate_history: this.selectedDate.end
      }

      if (this.filter.type) {
        Object.assign(data, {
          isschedule: this.filter.type.value
        })
      }
      // if (this.filter.roundStart) {
      //   Object.assign(data, {
      //     startdate_history: this.filter.roundStart,
      //   })
      // }
      // if (this.filter.roundEnd) {
      //   Object.assign(data, {
      //     enddate_history: this.filter.roundEnd,
      //   })
      // }

      api.getcmsviewcartshistory(data, (err, response) => {
        this.loading = false
        if (response.data) {
          this.rawusers = response.data
        } else {
          this.rawusers = []
        }
      })
    },
    exportCartSummary: function () {
      let vm = this
      let csvContent = ''
      if (vm.loading) {
        return false
      }
      var csvdata =
        'Shop code,Shop name,Province,Name,Product name,Quantity,Unit,Price,Discount price,Date&Time\r\n'

      this.filteredUser.forEach((el) => {
        csvdata += `${el.cardnumber ? el.cardnumber : '-'},${el.realname ? el.realname : '-'},${
          el.address ? el.address : '-'
        },${el.name ? el.name : '-'},${el.productname ? el.productname : '-'},${
          el.quantity ? el.quantity : '-'
        },${el.option ? el.option : '-'},${el.price ? el.price : '-'},${
          el.discountprice ? el.discountprice : '-'
        },${el.timestamp ? moment(el.timestamp).format('DD/MM/YYYY HH:mm') : '-'}\r\n`
      })
      vm.exportCsv(csvdata, 'cartsummary')
    },
    getDateFormatted(val) {
      if (val) {
        return moment(val).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    onFilter() {
      this.getUser()
    },
    clearDateTime(item) {
      if (item == 'roundStart') {
        this.filter.roundStart = ''
      }
      if (item == 'roundEnd') {
        this.filter.roundEnd = ''
      }

      this.getUser()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/CartReportScgdistribute.vue